import React, {useContext} from 'react'
import './Portfolio.css'
import SwiperCore , { Autoplay } from 'swiper'
import {Swiper, SwiperSlide} from 'swiper/react'
import QuickTalkMain from '../../protofolio_imgs/quickTalk_2.0.png'
import QuickTalkChat from '../../protofolio_imgs/quickTalk_chat.png'
import MonsterRolodex from '../../protofolio_imgs/monster_rolodex.png'
import TodoList from '../../protofolio_imgs/todoList.png'
import WoodHouse from '../../protofolio_imgs/wood_house.png'
import 'swiper/css'
import {themeContext} from '../../Context'



function Portfolio() {
  SwiperCore.use([Autoplay])
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
  return (
    <div className='portfolio' id='Protfolio'>
        <span style={{color: darkMode ? 'white' : ''}}>Recent Projects</span>
        <span>Portfolio</span>
        <Swiper
            className='portfolio-slider'
            spaceBetween={30}
            slidesPerView={3}
            grabCursor={true}
            autoplay={{
                delay: 1000,
                disableOnInteraction: false
            }}
        >
            <SwiperSlide>
                <img src={QuickTalkMain} alt="" />
            </SwiperSlide>
            <SwiperSlide>
                <img src={QuickTalkChat} alt="" />
            </SwiperSlide>{" "}
            <SwiperSlide>
                <img src={MonsterRolodex} alt="" />
            </SwiperSlide>
            <SwiperSlide>
                <img src={TodoList} alt="" />
            </SwiperSlide>
            <SwiperSlide>
                <img src={WoodHouse} alt="" />
            </SwiperSlide>
            <div
                className='blur p-blur2'
                style={{background: "rgb(3, 240, 126)"}}>

            </div>
        </Swiper>
        <div className='blur p-blur1' style={{background: "#C1F5FF"}}>

        </div>
    </div>
    
  )
}

export default Portfolio